import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  username: string | null;
  isAdmin: boolean;
  mustChangePassword: boolean;
}

const initialState: AuthState = {
  isAuthenticated: !!localStorage.getItem('token'),
  token: localStorage.getItem('token'),
  username: localStorage.getItem('username'),
  isAdmin: false,
  mustChangePassword: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ token: string; username: string }>) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.username = action.payload.username;
    },
    setProfile: (state, action: PayloadAction<{ isAdmin: boolean; mustChangePassword: boolean }>) => {
      state.isAdmin = action.payload.isAdmin;
      state.mustChangePassword = action.payload.mustChangePassword;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.username = null;
      state.isAdmin = false;
      state.mustChangePassword = false;
      localStorage.removeItem('token');
      localStorage.removeItem('username');
    },
  },
});

export const { login, setProfile, logout } = authSlice.actions;
export default authSlice.reducer;
